module.exports = __webpack_public_path__ + "static/key-swordsofditto-7eb8ff0eaa328659a65b31e83b667097.webp";